import React from "react";
import { connect } from "react-redux";
import debounce from "lodash.debounce";
import USZipCode from "src/components/CustomizePayment/ZipCode/USZipCode";
import CAPostalCode from "src/components/CustomizePayment/ZipCode/CAPostalCode";
import { getZipCode, getZipCodeSource } from "src/store/selectors/person";
import { validateZip } from "Shared/Form/validation";
import { patchDealPerson } from "src/store/dataService/actions/deal";
import {ApplicationStore} from "src/store";

interface ZipCodeProps {
    placeholder?: string;
}

const ZipCode = ({
    placeholder,
    isCountryUS,
    uuid,
    zipCode,
    zipCodeSource,
    patchDealPersonWithZipCode
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & ZipCodeProps) => {

    const [ zipCodeValue, updateZipCodeValue ] = React.useState(zipCode);

    const handleZipCodeInputValueChange = ( e: { target: { value: string } }) => {
        const userEnteredZip = e.target.value.toUpperCase();
        updateZipCodeValue(userEnteredZip)
        if (userEnteredZip !== "" && userEnteredZip !== zipCode && validateZip(userEnteredZip, isCountryUS)) {
            debounceUpdateDealPerson( userEnteredZip )
        }
    };

    const debounceUpdateDealPerson = debounce((zip: string) => {
        (patchDealPersonWithZipCode(uuid, {
            zip: zip as any,
        }));
    }, 1000);

    return (
        <>
            {(isCountryUS) ? (
                <USZipCode
                    locationType={zipCodeSource}
                    onChange={handleZipCodeInputValueChange}
                    value={zipCodeValue}
                    placeholder={placeholder}
                />
            ) : (
                <CAPostalCode
                    locationType={zipCodeSource}
                    value={zipCodeValue}
                    onBlur={handleZipCodeInputValueChange}
                    onChange={handleZipCodeInputValueChange}
                    placeholder={placeholder}
                />
            )}
        </>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    isCountryUS: state.account?.address?.country === "US",
    uuid: state.deal.uuid as string,
    zipCode: getZipCode(state) as string,
    zipCodeSource: getZipCodeSource(state)
});

const mapDispatchToProps = {
    patchDealPersonWithZipCode: patchDealPerson,
};

export default connect(mapStateToProps, mapDispatchToProps)(ZipCode);
